
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/termos-e-condicoes",
      function () {
        return require("private-next-pages/legal/termos-e-condicoes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/termos-e-condicoes"])
      });
    }
  